const withButtonStates = function () {
    this.triggerActionEvent = function (action, event) {
        var button = this.select(action);
        if (button.data('disabled')) {
            return;
        }
        this.trigger(event);
    };

    this.updateActionButtonState = function (button, state) {
        if (typeof button === 'string') {
            button = this.select(button);
        }
        button.data('state', state);
        button.attr('data-state', state);
    };

    this.selectButton = function (button) {
        if (typeof button === 'string') {
            button = this.select(button);
        }
        button.data('selected', true);
        button.attr('data-button-selected', true);
    };

    this.unselectButton = function (button) {
        if (typeof button === 'string') {
            button = this.select(button);
        }
        button.data('selected', false);
        button.attr('data-button-selected', null);
    };

    this.disableButton = function (button) {
        if (typeof button === 'string') {
            button = this.select(button);
        }
        button.data('disabled', true);
        button.attr('data-disabled', true);
        button.attr('data-button-disabled', true);
    };

    this.enableButton = function (button) {
        if (typeof button === 'string') {
            button = this.select(button);
        }
        button.data('disabled', false);
        button.removeAttr('data-disabled');
        button.attr('data-button-disabled', null);
    };

    this.hideButton = function (button) {
        if (typeof button === 'string') {
            button = this.select(button);
        }
        button.attr('data-hidden', true);
    };

    this.showButton = function (button) {
        if (typeof button === 'string') {
            button = this.select(button);
        }
        button.removeAttr('data-hidden');
    };

    this.switchButtons = function (button1, button2) {
        this.showButton(button1);
        this.hideButton(button2);
    };

    // --------------------------------------------------
    // Callbacks
    //
    // These callbacks make it simple to bind to a given
    // flight event without the need for an intermediate step.
    // --------------------------------------------------

    this.disableButtonCb = function (button) {
        return function () {
            this.disableButton(button);
        }.bind(this);
    };

    this.enableButtonCb = function (button) {
        return function () {
            this.enableButton(button);
        }.bind(this);
    };
};

export default withButtonStates;



// WEBPACK FOOTER //
// ./src/web/js/entry/mixins/with-button-states.js